import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  DOCUMENTS_EXPORT__CANCEL,
  DOCUMENTS_EXPORT__INITIALIZE,
  DOCUMENTS_EXPORT__LABEL_SELECTED,
  DOCUMENTS_EXPORT__LIST_FETCH_END,
  DOCUMENTS_EXPORT__LIST_FETCH_FAILURE,
  DOCUMENTS_EXPORT__LIST_FETCH_REQUEST,
  DOCUMENTS_EXPORT__LIST_FETCH_RESTART,
  DOCUMENTS_EXPORT__LIST_FETCH_START,
  DOCUMENTS_EXPORT__LIST_FETCH_SUCCESS,
  DOCUMENTS_EXPORT__TOTAL_DOCUMENTS_COUNT_FETCH_FAILURE,
  DOCUMENTS_EXPORT__TOTAL_DOCUMENTS_COUNT_FETCH_REQUEST,
  DOCUMENTS_EXPORT__TOTAL_DOCUMENTS_COUNT_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import DocumentListFetchRangeType from '@app/store/documentsExport/DocumentListFetchRangeType';
import { DocumentListItemType } from '@app/store/transport-layer/document/documents';

export function documentsExportCancel() {
  return {
    type: DOCUMENTS_EXPORT__CANCEL,
  };
}

export function documentsExportLabelSelected(payload: {
  assigned?: boolean;
  labelId: string | null;
}) {
  return {
    type: DOCUMENTS_EXPORT__LABEL_SELECTED,
    payload,
  };
}

export function documentsExportFetchTotalDocumentsCount() {
  return {
    type: DOCUMENTS_EXPORT__TOTAL_DOCUMENTS_COUNT_FETCH_REQUEST,
  };
}

export function documentsExportFetchTotalDocumentsCountSuccess(payload: number) {
  return {
    type: DOCUMENTS_EXPORT__TOTAL_DOCUMENTS_COUNT_FETCH_SUCCESS,
    payload,
  };
}

export function documentsExportFetchTotalDocumentsCountFailure(payload: AxiosError) {
  return {
    type: DOCUMENTS_EXPORT__TOTAL_DOCUMENTS_COUNT_FETCH_FAILURE,
    payload,
    error: true,
  };
}

export function documentsExportFetchList(payload: { limit: number; offset: number }) {
  return {
    type: DOCUMENTS_EXPORT__LIST_FETCH_REQUEST,
    payload,
  };
}

export function documentsExportFetchListSuccess(payload: {
  documentsList: DocumentListItemType[];
  maxPage: number;
  totalDocumentsCount: number;
}) {
  return {
    type: DOCUMENTS_EXPORT__LIST_FETCH_SUCCESS,
    payload,
  };
}

export function documentsExportFetchListFailure(payload: AxiosError) {
  return {
    type: DOCUMENTS_EXPORT__LIST_FETCH_FAILURE,
    payload,
    error: true,
  };
}

export function documentsExportInitialize() {
  return {
    type: DOCUMENTS_EXPORT__INITIALIZE,
  };
}

export function documentsExportFetchListRestart() {
  return {
    type: DOCUMENTS_EXPORT__LIST_FETCH_RESTART,
  };
}

export function documentsExportFetchListStart(payload: {
  limit: number;
  documentListFetchRangeType: DocumentListFetchRangeType;
  range: { end: number; start: number } | null;
  offset: number;
}) {
  return {
    type: DOCUMENTS_EXPORT__LIST_FETCH_START,
    payload,
  };
}

export const documentsExportFetchListEnd = createAction<
  { totalDocumentsCount: number },
  typeof DOCUMENTS_EXPORT__LIST_FETCH_END
>(DOCUMENTS_EXPORT__LIST_FETCH_END);

export type DocumentsExportAction =
  | ReturnType<typeof documentsExportCancel>
  | ReturnType<typeof documentsExportFetchList>
  | ReturnType<typeof documentsExportFetchListSuccess>
  | ReturnType<typeof documentsExportFetchListFailure>
  | ReturnType<typeof documentsExportFetchListRestart>
  | ReturnType<typeof documentsExportFetchListStart>
  | ReturnType<typeof documentsExportFetchListEnd>
  | ReturnType<typeof documentsExportFetchTotalDocumentsCount>
  | ReturnType<typeof documentsExportFetchTotalDocumentsCountSuccess>
  | ReturnType<typeof documentsExportFetchTotalDocumentsCountFailure>
  | ReturnType<typeof documentsExportLabelSelected>
  | ReturnType<typeof documentsExportInitialize>;
